/**
 * TAS Command — Sistema Digitale di Gestione Operazioni SAR
 *
 * Copyright (c) 2026 Matteo MESSINA, Alfonso CECERE
 * Tutti i diritti riservati.
 *
 * Sviluppato dagli autori a titolo personale, al di fuori
 * dell'orario di servizio e senza utilizzo di risorse o
 * strumentazione dell'amministrazione di appartenenza.
 *
 * Qualsiasi riproduzione, distribuzione o utilizzo non
 * autorizzato è vietato ai sensi della L. 633/1941.
 *
 * Autori:
 *   Matteo MESSINA  — VE, Comando VVF Benevento, Servizio TAS
 *   Alfonso CECERE  — VE, Comando VVF Benevento, Servizio TAS
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registra il Service Worker in produzione per supporto offline
registerSW({
  onSuccess: () => console.info("[App] PWA installata — disponibile offline."),
  onUpdate: () => console.info("[App] Nuova versione disponibile al prossimo riavvio."),
});
